import PremiumHero from "../components/premium/PremiumHero";
import LaunchEventSection from "../components/premium/LaunchEventSection";
// import ProductsSection from "../components/premium/ProductsSection";
// import AboutSection from "../components/premium/AboutSection";
import ServicesSection from "../components/premium/ServicesSection";
import WhyChooseUs from "../components/premium/WhyChooseUs";
// import TestimonialsSection from "../components/premium/TestimonialsSection";

export default function HomePage() {
  return (
    <main className="premium-site bg-[#071120]">
      <PremiumHero />
      <LaunchEventSection />
      {/* <ProductsSection /> */}
      {/* <AboutSection /> */}
      <ServicesSection />
      <WhyChooseUs />
      {/* <TestimonialsSection /> */}
    </main>
  );
}
